export default __webpack_public_path__ + "static/media/HeaderMechanic.7283fc40.png";